<template>
  <div>
    <script id="editor" type="text/plain"></script>
  </div>
</template>
<script>
export default {
  name: "UEditor",
  props: {
    id: {
      type: String
    },
    content: {
      type: String
    }
    // config: {
    //     type: Object
    // }
  },
  data() {
    return {
      editor: null,
      config: {
        //可以在此处定义工具栏的内容
        // toolbars: [
        //  ['fullscreen', 'undo', 'redo','|','bold', 'italic', 'underline',
        //  '|','superscript','subscript','|', 'insertorderedlist', 'insertunorderedlist',
        //  '|','fontfamily','fontsize','justifyleft','justifyright','justifycenter','justifyjustify']
        // ],
        autoHeightEnabled: false,
        autoFloatEnabled: true,
        initialContent: "请输入内容", //初始化编辑器的内容,也可以通过textarea/script给值，看官网例子
        autoClearinitialContent: true, //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了
        initialFrameWidth: null,
        initialFrameHeight: 450,
        BaseUrl: "",
        UEDITOR_HOME_URL: "/ueditor/" //线上服务器配置'/ueditor/'   本地配置 '/src/static/ueditor/'
      }
    };
  },
  mounted() {
    //初始化UE
    const _this = this;
    setTimeout(() => {
      var UE = window.UE || {};
      _this.editor = UE.delEditor("editor");
      _this.editor = UE.getEditor("editor", this.config);
      _this.ue = UE.getEditor("editor", this.config);
    }, 400);

    // window.UE.ready(function() {
    //     //默认显示内容
    //     window.UE.setContent('<p style="color:silver">第一条 文明发言,如有违反，后果将由您个人自行承担。</p>');
    //     //文本框获取焦点时清空默认显示的内容
    //     window.UE.addListener("focus", function(){
    //         window.UE.setContent('');
    //     });
    //     //文本框是去焦点时,若内容为空则显示默认显示的内容
    //     window.UE.addListener("blur", function(){
    //         if(!window.UE.getContent()){
    //             window.UE.setContent('<p style="color:silver">文明发言,如有违反，后果将由您个人自行承担。</p>');
    //         }
    //     });
    // });
  },
  destoryed() {
    this.editor.destory();
  },
  methods: {
    getUEContent: function() {
      return this.editor.getContent();
    },
    getContentTxt: function() {
      return this.editor.getContentTxt();
    },
    addContent: function(newValue) {
      var _this = this;
      _this.editor.ready(function() {
        _this.editor.setContent(newValue);
      });
    }
  },
  watch: {
    content(newValue, oldValue) {
      this.initialContent = newValue;
      this.addContent(newValue);
    }
  }
};
</script>
